<template>
  <div id="container">
    <!-- <router-view></router-view> -->
    <div
      class="landscape-view position-absolute w-full z-99 d-portrait-none"
      id="landscape-view-header"
    >
      <div
        class="landscape-header"
        v-if="
          !isSubtitleSettingsVisible && !isSubtitlesVisible && !isQuizVisible
        "
      >
        <div
          class="d-flex justify-content-between align-items-center h-56 landscape-mgt-40"
        >
          <!-- <a href="#" class="brand-logo center t-headline8 t-color-dark  l-spacing6">구매 정보</a> -->
          <div
            class="d-flex align-items-center flex-grow-1 landscape-top landscape-absolute-video-header"
          >
            <button
              id="btnClose"
              class="d-portrait-none"
              @click="moveLearnView()"
            ></button>
            <div
              class="d-landscape-block d-portrait-none t-body3 lesson_name sidenav-trigger mgl-16 cloase-landscape flex-grow-1"
            >
              {{ lessonName }}
            </div>

            <transition :name="mainTransitionName" mode="out-in">
              <div
                v-show="isVideoVisible"
                id="mainContainer"
                class="d-portrait-none"
              >
                <div v-show="isVideoVisible" id="mainContainer">
                  <div id="videoDetails">
                    <div class="subtitles">
                      <div
                        @click="onToggleSubtitles()"
                        class="typography--b6 d-block firstSubtitle"
                      ></div>
                      <div
                        @click="onToggleSubtitles()"
                        class="typography--b4 d-block secondSubtitle"
                      ></div>
                    </div>
                  </div>

                  <like-and-bookmark
                    class="socialMt"
                    :likesCount="likesCount"
                    :clippingCount="clippingCount"
                    :likes="likes"
                    :clipping="clipping"
                    @updateLikesCount="updateLikesCount"
                    @updateBookmarkCount="updateBookmarkCount"
                  ></like-and-bookmark>
                </div>
              </div>
            </transition>

            <button
              @click="onToggleSubtitleSettings()"
              class="d-portrait-none"
              id="btnSettingSubtitles"
            ></button>
            <div
              id="subtitles"
              v-if="setedFirstSubtitle || setedSecondSubtitle"
            >
              <div class="typography--h7 firstSubtitle"></div>
              <div class="typography--e-b1 secondSubtitle"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- {{isPortrait}} -->
    <transition :name="mainTransitionName" mode="out-in">
      <div id="videoContainer" v-show="isVideoVisible">
        <span class="video-watermark dark">{{
          personalInfo ? personalInfo.userId : ""
        }}</span>
        <span class="video-watermark light">{{
          personalInfo ? personalInfo.userId : ""
        }}</span>
        <!-- <div
          style="position: absolute; left: 72px; top: 30px; font-size: 20px"
          class="d-landscape-block d-portrait-none t-body4"
        >
          {{ lessonName }}
        </div> -->
        <video id="elementVideo">
          Your browser does not support the video tag.
          <track
            v-for="(subtitle, index) in subtitles"
            kind="captions"
            :src="subtitle.file"
            :srclang="subtitle.language.value"
            :label="subtitle.language.text"
            :key="index"
          />
        </video>

        <button
          id="btnClose"
          class="d-landscape-none"
          @click="moveLearnView()"
        ></button>
        <div class="d-landscape-block d-portrait-none t-body4 lesson_name neww">
          {{ lessonName }}
        </div>
        <button
          @click="moveQuestion()"
          id="btnQnA"
          class="d-landscape-none"
        ></button>
        <button
          @click="onToggleSubtitleSettings()"
          class="d-landscape-none"
          id="btnSettingSubtitles"
        ></button>
        <div id="subtitles" v-if="setedFirstSubtitle || setedSecondSubtitle">
          <div class="typography--h7 firstSubtitle"></div>
          <div class="typography--e-b1 secondSubtitle"></div>
        </div>
      </div>
    </transition>

    <!-- <div>
            <button @click="onToggleSubtitleSettings()">자막 설정</button>
        </div> -->

    <transition :name="mainTransitionName" mode="out-in">
      <div
        v-show="isVideoVisible"
        class="d-portrait-none"
        id="videoButtonsContainer"
      >
        <!-- <button @click="onToggleSubtitleSettings()" class="typography--b3">
          {{ $t("1078") }}
        </button>
        <button @click="moveQuestion()" class="typography--b3">
          {{ $t("1053") }}
        </button>
        <button @click="onTogglePlaylist()" class="typography--b3">
          {{ $t("1054") }}
        </button> -->
      </div>
    </transition>

    <transition :name="mainTransitionName" mode="out-in">
      <div v-show="isVideoVisible" id="mainContainer" class="d-landscape-none">
        <div v-show="isVideoVisible" id="mainContainer">
          <div id="videoDetails">
            <div class="subtitles">
              <div
                @click="onToggleSubtitles()"
                class="typography--b6 d-block firstSubtitle"
              ></div>
              <div
                @click="onToggleSubtitles()"
                class="typography--b4 d-block secondSubtitle"
              ></div>
            </div>
            <div>
              <span class="typography--s4 d-block mt-3">{{ lessonName }}</span>
              <span class="typography--b7 d-block mt-2 color-secondary mb-3"
                >{{ rate }} %</span
              >
            </div>
          </div>

          <like-and-bookmark
            :likesCount="likesCount"
            :clippingCount="clippingCount"
            :likes="likes"
            :clipping="clipping"
            @updateLikesCount="updateLikesCount"
            @updateBookmarkCount="updateBookmarkCount"
          ></like-and-bookmark>
        </div>
      </div>
    </transition>

    <div id="resizeContainer">
      <div></div>
    </div>

    <transition name="fade" mode="out-in">
      <videotype-subtitle
        ref="videotypeSubtitle"
        v-on:subtitles-toggle="onToggleSubtitles()"
        v-if="isSubtitlesVisible"
        :firstTrack="firstTrackCues"
        :secondTrack="secondTrackCues"
        :lessonName="lessonName"
        :firstTrackStartTime="firstTrackStartTime"
      />
    </transition>

    <transition name="slide" mode="out-in">
      <timeline-quiz-detail
        @closeQuizDetail="closeQuizDetail()"
        v-if="isQuizVisible"
        :currentTimelineContents="currentTimelineContents"
      />
      <qna-component v-on:qna-toggle="onToggleQnA()" v-if="isQnAVisible" />

      <videoType-setting-subtitles
        v-on:subtitle-settings-toggle="onToggleSubtitleSettings()"
        v-if="isSubtitleSettingsVisible"
        :subtitles="lessonData.video.subtitles"
        :setedFirstSubtitle="setedFirstSubtitle"
        :setedSecondSubtitle="setedSecondSubtitle"
        @setSubtitles="setSubtitles"
      />
    </transition>

    <transition :name="mainTransitionName" mode="out-in">
      <div v-show="isControlsVisible" id="seekBarContainer" class="mt-3">
        <range-slider
          id="seekBar"
          type="range"
          min="0"
          max="100"
          v-model="currentSlideValue"
          data-orientation="vertical"
          @input="onSliding"
          @change="onChanged"
        ></range-slider>
        <div id="timeRange">
          <span
            class="typography--ht-helper color-secondary"
            v-text="currentTimeParsed"
          ></span>
          <span
            class="typography--ht-helper color-secondary"
            v-text="fullLength"
          ></span>
          <div class="clearfix"></div>
        </div>
      </div>
    </transition>

    <transition :name="mainTransitionName" mode="out-in">
      <div v-show="isControlsVisible" id="controls">
        <a id="btnMoveBackward" @click="moveBackward()"></a>
        <a id="btnBackward" @click="moveBackward()"></a>
        <a v-show="!isPlaying" id="btnPlay" @click="onTogglePlayPause()"></a>
        <a v-show="isPlaying" id="btnPause" @click="onTogglePlayPause()"></a>
        <a id="btnForward" @click="moveForward()"></a>
        <a id="btnMoveForward" @click="moveForward()"></a>
      </div>
    </transition>
    <!-- {{isLecturesVisible}} -->
    <transition :name="mainTransitionName" mode="out-in">
      <div v-show="isLecturesVisible" id="playlistContainer">
        <div class="title">
          <button @click="onTogglePlaylist()" id="btnPlaylistClose"></button>
          <span
            class="typography--s4 text-center"
            :class="{
              'typography--b4': !showLectureList,
              'text-left': !showLectureList,
            }"
            v-if="nextLessonName !== null"
          >
            {{
              showLectureList
                ? `${$t("1086")}`
                : `${$t("1045")}: ${nextLessonName}`
            }}
          </span>
          <span
            class="typography--s4 text-center"
            :class="{
              'typography--b4': !showLectureList,
              'text-left': !showLectureList,
            }"
            v-else
          >
            {{ $t("1999") }}
          </span>
          <!-- <span v-else id="lecturesTitle" class="typography--b4 text-left">Next: {{ nextLessonName }}</span> -->
          <i v-if="!showLectureList" class="material-icons" id="btnPlaylistToggle" @click="onTogglePlaylist()">expand_less</i>
          <i v-else class="material-icons d-flex justify-content-center align-items-center" id="btnPlaylistToggle" @click="onTogglePlaylist()">expand_more</i>
          <div class="clearfix"></div>
        </div>
        <div class="lectures-list">
          <lessons-list
            :lessonsList="lessonsList"
            :currentProgressionId="currentProgressionId"
          ></lessons-list>
        </div>
      </div>
    </transition>

    <div id="seekBarTooltip">
      <div>
        <img class="videoPreview" :src="thumbnailURL" alt="Video Preview" />
        <small class="videoTime mt-2" v-text="currentTimeParsed"></small>
      </div>
    </div>

    <!-- 퀴즈 팝업 -->
    <transition name="bounce">
      <timeline-quiz-pop
        :currentTimelineContents="currentTimelineContents"
        v-if="isTimelineQuiz"
        @closeQuizPop="closeQuizPop()"
        @openQuizDetail="openQuizDetail()"
      />
    </transition>

    <!-- 리소스 팝업 -->
    <transition name="bounce">
      <timeline-resource-pop
        :currentTimelineContents="currentTimelineContents"
        v-if="isTimelineResource"
        @closeResource="closeResource()"
        @openResource="openResource()"
      />
    </transition>

    <pop-next-lesson
      :nextLesson="nextLesson"
      v-if="endedLesson && nextLesson"
      @moveLearnView="moveLearnView"
    ></pop-next-lesson>
  </div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 비디오 컨텐츠 컴포넌트(my learning lesson study - video content component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from "@/api/learnApi.js";
import { videoTypeMixins } from "../../mixins/videoType.js";

import VideoTypeSubtitle from "./VideoTypeSubtitle.vue";
import VideoTypeSettingSubtitles from "./VideoTypeSettingSubtitles.vue";
import LessonsList from "./LessonsList.vue";

import TimelineQuizPop from "./TimelineQuizPop.vue";
import TimelineQuizDetail from "./TimelineQuizDetail.vue";
import TimelineResourcePop from "./TimelineResourcePop.vue";
import LikeAndBookmark from "./LikeAndBookmark.vue";
import PopNextLesson from "./PopNextLesson.vue";
import { captureApiError } from "@/utils/sentryApiHandler.js"

export default {
  data() {
    return {
      lessonData: null,
      lessonName: "",
      video: null,
      lessonsList: [],
      nextLessonName: null,
      currentProgressionId: "",
      rate: 0,
      last: 0,
      recent: 0,
      showLectureList: false,

      //타임라인 관련 데이터(timeline data)
      isTimelineQuiz: false,
      isTimelineResource: false,
      timelineContents: [],
      currentTimelineContents: null,

      // 북마크 좋아요 관려 데이터(like & bookmark data)
      isLiked: false,
      isBookmarked: false,
      likes: false,
      likesCount: 0,
      clipping: false,
      clippingCount: 0,

      // 자막 관련 데이터(subtitles data)
      subtitles: [],
      setedFirstSubtitle: "",
      setedSecondSubtitle: "",
      firstTrack: null,
      secondTrack: null,
      firstTrackStartTime: 0,
      secondTrackStartTime: 0,
      firstTrackCues: null,
      secondTrackCues: null,

      endedLesson: false,
      nextLesson: null,

      personalInfo: null,

      // nextLessonDialog: null
    };
  },
  mixins: [videoTypeMixins],
  components: {
    "videotype-subtitle": VideoTypeSubtitle,
    "videoType-setting-subtitles": VideoTypeSettingSubtitles,
    "lessons-list": LessonsList,
    "timeline-quiz-detail": TimelineQuizDetail,
    "timeline-quiz-pop": TimelineQuizPop,
    "timeline-resource-pop": TimelineResourcePop,
    "pop-next-lesson": PopNextLesson,
    "like-and-bookmark": LikeAndBookmark,
  },

  computed: {
    setCurrentSlideValue() {
      return parseInt(this.currentSlideValue);
    },
  },

  mounted() {
    let params = this.setParams();
    let responseData = null;

    //차시 컨텐츠 정보 API 호출(get lesson contents data)
    learnApi
      .learnLessonContents(params)
      .then((response) => {
        responseData = response.data.data;
        this.lessonData = responseData;
        this.lessonName = this.lessonData.lessonName;
        this.rate = this.lessonData.rate;
        this.video = this.lessonData.video;
        this.last = this.lessonData.last;
        this.recent = this.lessonData.recent;
        this.totalTime = this.lessonData.video.duration;
        this.subtitles = this.lessonData.video.subtitles;
        this.thumbnails = this.lessonData.video.thumbnails[0];
        this.currentProgressionId = this.lessonData.progressionId;

        this.elementVideo.src = this.video.file;
        // if (this.thumbnails) {
        //     this.elementVideo.poster = this.thumbnails
        // }else {
        //     this.elementVideo.poster = require('@/images/video_thum.png')
        // }

        this.likes = this.lessonData.likes;
        this.likesCount = this.lessonData.likesCount;
        this.clipping = this.lessonData.clipping;
        this.clippingCount = this.lessonData.clippingCount;

        // 학습중일 경우 처음부터 보기 이어보기 팝업(If you are learning, pop-up view from the beginning)
        if (this.rate > 0 && this.rate < 100) {
          this.$confirm({
            title: this.$t("173"), // '학습 중인 강의입니다.',
            content: this.$t("174") + "<br>" + this.$t("175"), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
            accept: this.$t("177"), //'이어서 보기',
            cancel: this.$t("176"), //'처음부터 보기',
          })
            .then(() => {
              this.elementVideo.currentTime = this.recent;
              this.elementVideo.play();
            })
            .catch(() => {
              this.elementVideo.currentTime = 0;
              this.elementVideo.play();
            });
        } else {
          this.elementVideo.play();
        }

        this.fetchLectureList();
      })
      .catch((err) => {
        captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
      });

    // 동영상 재생시 자막 설정(Subtitle settings during video playback)
    this.elementVideo.onplay = () => {
      this.setSubtitles();
    };

    // 동영상 끝났을 경우 진도 저장(Save progress when video is over)
    this.elementVideo.onended = () => {
      this.endedLesson = true;
      this.updateProgress();
    };

    // 동영상 재생 준비 완료되었을 경우 재생(Play when video is ready to play)
    this.elementVideo.onloadeddata = () => {
      if (this.elementVideo.readyState >= 2) {
        this.elementVideo.play();
      }
    };

    // 타임라인 컨텐츠 정보 API 호출(get timeline data)
    learnApi
      .learnLessonTimelinecontents(params)
      .then((response) => {
        responseData = response.data.data;
        this.timelineContents = responseData;
      })
      .catch((err) => {
        captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
      });

    learnApi.getMemberInfo().then((response) => {
      this.personalInfo = response.data.data;
    }).catch((err) => {
      captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
    });

    console.log(this.$data)
  },

  beforeDestroy() {
    // 비디오 이벤트 리스너 제거
    if (this.elementVideo) {
      this.elementVideo.onended = null;
      this.elementVideo.onplay = null;
      this.elementVideo.onloadeddata = null;
      
      // 자막 이벤트 리스너 제거
      if (this.firstTrack) {
        this.firstTrack.oncuechange = null;
      }
      if (this.secondTrack) {
        this.secondTrack.oncuechange = null;
      }
    }
  },

  methods: {
    // 진도저장 API 호출(update progress)
    updateProgress() {
      let params = this.setParams();
      let responseData = null;
      learnApi
        .learnLessonProgression(params)
        .then((response) => {
          responseData = response.data.data;
          // console.log(responseData)
          this.rate = responseData.rate;
          this.last = responseData.last;
        })
        .catch((err) => {
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });
    },

    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        total: this.elementVideo.duration,
        current: this.elementVideo.currentTime,
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },

    // 자막 설정(set subtitles)
    setSubtitles(data) {
      let firstSubtitle = document.getElementsByClassName("firstSubtitle");
      let secondSubtitle = document.getElementsByClassName("secondSubtitle");

      // 기본자막 설정(Default subtitle setting)
      if (!data && this.lessonData.video.subtitles.length) {
        data = {
          firstSubtitle: "",
          secondSubtitle: ""
        };
      }

      if (data) {
        // set first subtitles
        if (data.firstSubtitle) {
          this.setedFirstSubtitle = data.firstSubtitle;
          this.firstTrack = this.elementVideo.textTracks[
            _.findIndex(this.elementVideo.textTracks, (track) => {
              return track.language === data.firstSubtitle;
            })
          ];

          console.log("firstTrack", this.firstTrack);

          this.firstTrack.mode = "hidden";
          this.firstTrackCues = this.firstTrack.cues;
          // 비디오 진도 바뀔때(When the video progress changes)
          this.firstTrack.oncuechange = (e) => {
            let cue = this.firstTrack.activeCues[0];

            if (cue) {
              this.firstTrackStartTime = cue.startTime;
              for (let i = 0; i < firstSubtitle.length; i++) {
                firstSubtitle[i].classList.remove("on");
                firstSubtitle[i].innerHTML = "";
                firstSubtitle[i].classList.add("on");
                firstSubtitle[i].appendChild(cue.getCueAsHTML());
              }
            }
          };
        } else {
          if (this.firstTrack) {
            this.setedFirstSubtitle = "";
            this.firstTrack.oncuechange = () => {};
            this.firstTrack = null;
            this.firstTrackCues = null;
          }

          for (let i = 0; i < firstSubtitle.length; i++) {
            firstSubtitle[i].innerHTML = "";
          }
        }

        // set second subtitles
        if (data.secondSubtitle) {
          this.setedSecondSubtitle = data.secondSubtitle;
          this.secondTrack = this.elementVideo.textTracks[
            _.findIndex(this.elementVideo.textTracks, (track) => {
              return track.language === data.secondSubtitle;
            })
          ];

          this.secondTrack.mode = "hidden";
          this.secondTrackCues = this.secondTrack.cues;
          // 비디오 진도 바뀔때(When the video progress changes)
          this.secondTrack.oncuechange = (e) => {
            let cue = this.secondTrack.activeCues[0];
            this.secondTrackStartTime = cue.startTime;
            console.log("firstSubtitle", secondSubtitle);

            if (cue) {
              for (let i = 0; i < secondSubtitle.length; i++) {
                secondSubtitle[i].classList.remove("on");
                secondSubtitle[i].innerHTML = "";
                secondSubtitle[i].classList.add("on");
                secondSubtitle[i].appendChild(cue.getCueAsHTML());
              }
            }
          };
        } else {
          if (this.secondTrack) {
            this.setedSecondSubtitle = "";
            this.secondTrack.oncuechange = () => {};
            this.secondTrack = null;
            this.secondTrackCues = null;
          }
          for (let i = 0; i < secondSubtitle.length; i++) {
            secondSubtitle[i].innerHTML = "";
          }
        }
      }
    },

    //나의 학습 상세로 이동(Go to my learning details)
    moveLearnView() {
      let goBackBookMarkLessson = localStorage.getItem("videoBookMarkLesson");
      let goBackLikeLessson = localStorage.getItem("videoLikeLesson");
      if (goBackBookMarkLessson == "setVideoBookMarkLesson") {
        localStorage.removeItem("videoBookMarkLesson");
        this.$router.push({
          name: "BookMarkedLesson",
        });
      } else if (goBackLikeLessson == "setVideoLikeLesson") {
        localStorage.removeItem("videoLikeLesson");
        this.$router.push({
          name: "LikedLesson",
        });
      } else {
        this.$router.push({
          name: "LearnView",
          params: { learnId: this.$route.params.learnId },
          query: this.$route.query,
        });
      }
    },

    // update likes count
    updateLikesCount(data) {
      this.likes = data.likes;
      this.likesCount = data.likesCount;
    },

    // update bookmark count
    updateBookmarkCount(data) {
      this.clipping = data.clipping;
      this.clippingCount = data.clippingCount;
    },

    // 학습 목록 API 호출(get lesson list)
    fetchLectureList() {
      let responseData = null;
      let params = this.setParams();

      learnApi
        .learnViewCourses(params)
        .then((response) => {
          // Merging only lesson data from the course
          _.each(response.data.data, (course) => {
            this.lessonsList = this.lessonsList.concat(course.lessons);
          });

          // 다음 차시명 설정(set next lesson)
          let currentLessonIndex = _.findIndex(this.lessonsList, (lesson) => {
            return lesson.progressionId === this.currentProgressionId;
          });
          let nextLessonIndex =
            this.lessonsList.length > 1 &&
            this.lessonsList.length > currentLessonIndex
              ? (currentLessonIndex += 1)
              : -1;
          if (nextLessonIndex) {
            this.nextLesson = this.lessonsList[nextLessonIndex];
            if (this.nextLesson) this.nextLessonName = this.lessonsList[nextLessonIndex].name;
          }
        })
        .catch((err) => {
          captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        });
    },

    // 타임라인 퀴즈 팝업 닫기(Close the timeline quiz popup)
    closeQuizPop() {
      this.isTimelineQuiz = false;
    },

    // 질문하기로 이동(Go to Ask a Question)
    moveQuestion() {
      this.$router.push({
        name: "LessonViewQuestion",
        query: this.$route.query,
      });
    },
  },
};
</script>
<style scoped src="../../css/video.css"></style>
<style scoped>
#playlistContainer.show {
  z-index: 999;
}
span.video-watermark {
  position: absolute;
  /* left: 20px; */
  font-size: 12px;
  opacity: 0.25;
  cursor: none;
}
span.video-watermark.light {
  color: #fff;
  top: 50%;
  left: 40%;
  transform: translate(-40%, -50%) rotate(-45deg);
}
span.video-watermark.dark {
  color: #000000;
  top: 50%;
  left: 51%;
  transform: translate(-51%, -50%) rotate(-45deg);
}

.no-scroll.playing .lesson_name {
  display: none !important;
}
.no-scroll .lesson_name {
  display: none !important;
}
.no-scroll.overlay .lesson_name {
  display: initial !important;
}
.no-scroll.playing.overlay .lesson_name {
  display: initial !important;
}

@media (min-width: 480px) {
  span.video-watermark.light {
    left: 45%;
    transform: translateX(-45%) rotate(-45deg);
  }
}

@media (orientation: landscape) {
}
</style>
